import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import PerformancePlugin from './plugins/performance'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/css/variables.css'
import './assets/styles/admin-components.css'
import './style.css'
import App from './App.vue'

// Mark the application start time
if (window.performance) {
  window.performance.mark('appInit')
}

const app = createApp(App)
const pinia = createPinia()

// Register plugins
app.use(pinia)
app.use(router)
app.use(PerformancePlugin, {
  router,
  sampleRate: import.meta.env.PROD ? 0.1 : 1.0, // 100% in dev, 10% in prod
  reportToConsole: import.meta.env.DEV, // Only log to console in development
  reportToAnalytics: import.meta.env.PROD // Only send to analytics in production
})

// Auth store wird automatisch über Pinia initialisiert
console.log('[App] Pinia stores initialisiert')

// Mount the application
app.mount('#app')

// Mark the application mounted time
if (window.performance) {
  window.performance.mark('appMounted')
  window.performance.measure('appStartupTime', 'appInit', 'appMounted')
  
  // Log startup performance in development
  if (import.meta.env.DEV) {
    const measure = window.performance.getEntriesByName('appStartupTime')[0]
    console.info(`🚀 App startup time: ${measure.duration.toFixed(2)}ms`)
  }
}
